export function getMyDocumentsEndpoint(): string {
    return `/my-documents`;
}

export function getMyDocumentDownloadEndpoint(nodeId: string): string {
    return `${getMyDocumentsEndpoint()}/${nodeId}`;
}
